export const ADMIN_ORDER_FILTER_STORAGE_KEY = 'admin_portal_orders_filters_v1'
export const ADMIN_MERCHANT_FILTER_STORAGE_KEY = 'admin_portal_merchants_filters_v1'
export const ADMIN_CURRENT_ENV_STORAGE_KEY = 'admin_portal_current_env'

export type NetworkEnvironment = 'mainnet' | 'testnet'
export const NETWORK_ENVIRONMENTS: NetworkEnvironment[] = ['mainnet', 'testnet']

export const withNetworkStorageKey = (baseKey: string, mode: NetworkEnvironment): string =>
  `${baseKey}:${mode}`

export const ADMIN_FILTER_STORAGE_KEYS = [
  ADMIN_ORDER_FILTER_STORAGE_KEY,
  ADMIN_MERCHANT_FILTER_STORAGE_KEY,
]
